module.exports = __webpack_public_path__ + "img/css.7ca664e1.svg";